import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=3b440b95&"
import script from "./EmailList.vue?vue&type=script&lang=ts&"
export * from "./EmailList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports